import React from 'react';

import PropTypes from 'prop-types';

import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';
import { URL_IMAGES_I } from 'apps/promo/constants/UrlConstants';
import { useExtra } from 'apps/promo/hooks/selectors';

import styles from './AppDownloadButtons.module.css';
import { AppButton } from '../app-button/AppButton';

const isExcludedForCountry = (item, country) => item?.except_countries?.some((c) => c.code_a2 === country);

const AppDownloadButtons = (props) => {
    const extra = useExtra();
    const downloadButtons = extra?.downloadButtons;
    const country = extra?.noAuthFooter?.language?.country?.toUpperCase();

    const byType = {};
    for (const item of downloadButtons ?? []) {
        byType[item.type] = item;
    }

    const getUrl = (item) => {
        if (isExcludedForCountry(item, country)) {
            return undefined;
        }

        return props.isReferral ? item?.url_referral : item?.url;
    };

    const getPicture = () => {
        if (props.isReferral && byType.qr?.qr_code_referral) {
            return (
                <picture>
                    <img loading="lazy" decoding="async" alt="Scan to join PaySend" src={byType.qr?.qr_code_referral?.url} />
                </picture>
            );
        } else if (byType.qr?.qr_code) {
            return (
                <picture>
                    <img loading="lazy" decoding="async" alt="Scan to join PaySend" src={byType.qr?.qr_code.url} />
                </picture>
            );
        } else {
            return (
                <picture>
                    <source media="(min-width: 744px)" srcSet={`${URL_IMAGES_I}/smart-qr-code-1x-d.png 1x, ${URL_IMAGES_I}/smart-qr-code-2x-d.png 2x`} />
                    <source srcSet={`${URL_IMAGES_I}/smart-qr-code-1x-m.png 1x, ${URL_IMAGES_I}/smart-qr-code-2x-m.png 2x`} />
                    <img loading="lazy" decoding="async" alt="Scan to join PaySend" src={`${URL_IMAGES_I}/smart-qr-code-1x-m.png`} />
                </picture>
            );
        }
    };

    return (
        <>
            <div className={styles.appButtons}>
                <AppButton href={getUrl(byType.apple)} variant="apple" areaLabel="App Store" />
                <AppButton href={getUrl(byType.android)} variant="google" areaLabel="Google Play" />
                <AppButton href={getUrl(byType.huawei)} variant="huawei" areaLabel="AppGallery" />
            </div>
            <div className={styles.qrCodeBlock}>
                <div className={styles.qrCodeText}>
                    <PromoText variant={'quote'}>{byType.qr?.description}</PromoText>
                </div>
                <div className={styles.qrCode}>{getPicture()}</div>
            </div>
        </>
    );
};

AppDownloadButtons.propTypes = {
    isReferral: PropTypes.bool,
};

export default AppDownloadButtons;
